import { render, staticRenderFns } from "./VRangeSliderStyling.vue?vue&type=template&id=2d3ff8dd&scoped=true&"
import script from "./VRangeSliderStyling.vue?vue&type=script&lang=ts&"
export * from "./VRangeSliderStyling.vue?vue&type=script&lang=ts&"
import style0 from "./VRangeSliderStyling.vue?vue&type=style&index=0&id=2d3ff8dd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d3ff8dd",
  null
  
)

export default component.exports